import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown, BookMarked } from "lucide-react";
import { api, download } from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { Button } from "@/components/ui/button";

export default function Manuali() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/admin/manuali").then((r) => setItems(r.data)); }, []);
  const get = async (id) => {
    setBusy(id);
    try { await download(`/admin/manuali/${id}.pdf`); } catch (e) { toast.error(e.message); }
    setBusy("");
  };
  return (
    <div>
      <PageHeader title="Manuali d'uso" subtitle="Manuali in PDF con le schermate, uno per ogni ruolo, da inviare a studi, aziende e agenti" />
      <div className="grid gap-4 md:grid-cols-2">
        {items.map((m) => (
          <div key={m.id} className="lift flex flex-col justify-between gap-4 rounded-xl border border-slate-200 bg-white p-6" data-testid={`manuale-${m.id}`}>
            <div className="flex gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-slate-900 text-sky-300"><BookMarked className="h-5 w-5" /></div>
              <div><div className="font-display text-lg font-bold text-slate-900">{m.titolo}</div><div className="text-sm text-slate-500">{m.descrizione} · {m.capitoli} capitoli</div></div>
            </div>
            <Button className="w-fit bg-sky-600 hover:bg-sky-700" disabled={busy === m.id} data-testid={`manuale-download-${m.id}`} onClick={() => get(m.id)}>
              <FileDown className="mr-2 h-4 w-4" />{busy === m.id ? "Preparazione…" : "Scarica PDF"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
